export default {
  products: null,
  productDetail: null
}
